<template>
  <div>
    <v-toolbar elevation="0" class="mb-1 vb-custom-labels labels-index-toolbar">
      <CreateUpdateCategoryDialog :category="{}" @categoryUpdated="refreshCategories" :activeCategoryId="activeCategoryId">
        <v-btn v-if="$canControlTenantConfig()" class="bg-primary" elevation="0" data-cy="tenantLabels-options-createUpdateCategory">
          <v-icon>mdi-format-list-group-plus</v-icon>
          <span class="hidden-sm-and-down">
            {{ $t('routes.labels.newCategory') }}
          </span>
        </v-btn>
      </CreateUpdateCategoryDialog>

      <CreateUpdateLabelDialog
          v-bind:label="{}"
          @labelUpdated="refreshLabels"
          :disabled="hasCategories === false"
      >
        <v-btn
            v-if="$canControlTenantConfig()"
            class="bg-primary ml-3"
            elevation="0"
            data-cy="tenantLabels-options-createUpdateLabel"
            :disabled="hasCategories === false"
        >
          <v-icon>mdi-label</v-icon>
          <span class="hidden-sm-and-down">
            {{ $t('routes.labels.newLabel') }}
          </span>
        </v-btn>
      </CreateUpdateLabelDialog>
    </v-toolbar>

    <v-row>
      <v-col cols="12" md="4">
        <CategoryListView></CategoryListView>
      </v-col>
      <v-col cols="12" md="8">
        <LabelListView @labelUpdated="refreshLabels"></LabelListView>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useLabelStore } from '@/stores/LabelStore.js'
import LabelListView from './components/LabelListView.vue'
import CreateUpdateLabelDialog from './components/dialogs/CreateUpdateLabelDialog.vue';
import CategoryListView from './components/CategoryListView.vue'
import CreateUpdateCategoryDialog from './components/dialogs/CreateUpdateCategoryDialog.vue';

export default {
  name: "LabelsIndex",
  components: {
    LabelListView,
    CategoryListView,
    CreateUpdateCategoryDialog,
    CreateUpdateLabelDialog,
  },
  mounted() {
    if (!this.$canControlTenantConfig()) {
      this.$router.push('/console/index');
    }
  },
  methods: {
    stub() {
      console.log('stub');
    },
    goBack: function() {
      this.$router.go(-1);
    },
    refreshCategories: function() {
      const payload = {
        accessPointId: this.accessPointId,
      };

      const labelStore = useLabelStore();
      labelStore.refreshCategories(payload)
        .catch((error) => {
          console.error('Error fetching data', error);
        });
    },
    refreshLabels: function(selectedCategoryId) {
      if (this.activeCategoryId === selectedCategoryId) {
        const payload = {
          categoryId: selectedCategoryId,
          accessPointId: this.accessPointId,
        };

        const labelStore = useLabelStore();
        labelStore.refreshLabels(payload)
          .catch((error) => {
            console.error('Error fetching data', error);
          });
      }
    },
  },
  computed: {
    accessPointId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    hasCategories() {
      const labelStore = useLabelStore();
      return labelStore.getCategories.length > 0;
    },
    activeCategoryId: function() {
      const labelStore = useLabelStore();
      return labelStore.getActiveCategoryId;
    },
  },
}
</script>

<style scoped>
.vb-custom-labels {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 600px) {
  .vb-custom-labels .v-btn span {
    display: none;
  }
  .vb-custom-labels .v-btn {
    min-width: 0;
    padding: 0 8px;
  }
}

:deep(.v-theme--dark).labels-index-toolbar {
  background-color: #272727 !important;
}

:deep(.v-theme--light).labels-index-toolbar {
  background-color: white !important;
}
</style>
